import { SVGProps } from 'react';

const IcCalendarSelect = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={props.width || 25} height={props.height || 24} viewBox='0 0 25 24' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.79961 5.20005C5.35778 5.20005 4.99961 5.55822 4.99961 6.00005V20C4.99961 20.4419 5.35778 20.8 5.79961 20.8H19.7996C20.2414 20.8 20.5996 20.4419 20.5996 20V6.00005C20.5996 5.55822 20.2414 5.20005 19.7996 5.20005H5.79961ZM3.34961 6.00005C3.34961 4.23274 4.0323 3.55005 5.79961 3.55005H19.7996C21.5669 3.55005 22.2496 4.23274 22.2496 6.00005V20C22.2496 21.7674 21.5669 22.45 19.7996 22.45H5.79961C4.0323 22.45 3.34961 21.7674 3.34961 20V6.00005Z'
        fill={props.fill || '#232F3E'}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.9248 1.5C17.5461 1.5 18.0498 1.94072 18.0498 2.48438V5.76562C18.0498 6.30928 17.5461 6.75 16.9248 6.75C16.3035 6.75 15.7998 6.30928 15.7998 5.76562V2.48438C15.7998 1.94072 16.3035 1.5 16.9248 1.5Z'
        fill={props.fill || '#232F3E'}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.6748 1.5C9.29613 1.5 9.7998 1.94072 9.7998 2.48438V5.76562C9.7998 6.30928 9.29613 6.75 8.6748 6.75C8.05348 6.75 7.5498 6.30928 7.5498 5.76562V2.48438C7.5498 1.94072 8.05348 1.5 8.6748 1.5Z'
        fill={props.fill || '#232F3E'}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.7998 9.75C3.7998 9.33579 4.27386 9 4.85863 9H20.741C21.3258 9 21.7998 9.33579 21.7998 9.75C21.7998 10.1642 21.3258 10.5 20.741 10.5H4.85863C4.27386 10.5 3.7998 10.1642 3.7998 9.75Z'
        fill={props.fill || '#232F3E'}
      />
    </svg>
  );
};

export default IcCalendarSelect;
